import { render, staticRenderFns } from "./alreadyAllotDetail.vue?vue&type=template&id=46bb7ea6&scoped=true&"
import script from "./alreadyAllotDetail.vue?vue&type=script&lang=js&"
export * from "./alreadyAllotDetail.vue?vue&type=script&lang=js&"
import style0 from "./alreadyAllotDetail.vue?vue&type=style&index=0&id=46bb7ea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb7ea6",
  null
  
)

export default component.exports